"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessedText = exports.isRTLText = exports.isRTLLocale = exports.renderUnsafeHTML = exports.trackWebchatState = exports.trackMessage = exports.initializeAnalytics = exports.checkLocationOrigin = exports.downloadFile = exports.asyncDebounce = exports.isIE = exports.getOverridedComponent = void 0;
var html_truncate_1 = __importDefault(require("html-truncate"));
var react_1 = __importDefault(require("react"));
var react_children_utilities_1 = __importDefault(require("react-children-utilities"));
var react_ga_1 = __importDefault(require("react-ga"));
var snarkdown_1 = __importDefault(require("snarkdown"));
var getOverridedComponent = function (overrides, componentName) {
    if (overrides === null || overrides === void 0 ? void 0 : overrides[componentName]) {
        var _a = overrides[componentName], module_1 = _a.module, component = _a.component;
        if (module_1 && component) {
            return window.botpress[module_1][component];
        }
    }
};
exports.getOverridedComponent = getOverridedComponent;
exports.isIE = window.navigator.userAgent.match(/MSIE|Trident/) !== null;
var asyncDebounce = function (timeMs) { return __awaiter(void 0, void 0, void 0, function () {
    var lastClickInMs, debounce;
    return __generator(this, function (_a) {
        lastClickInMs = undefined;
        debounce = function (promise) {
            var now = Date.now();
            if (!lastClickInMs) {
                lastClickInMs = now;
            }
            if (now - lastClickInMs > timeMs) {
                lastClickInMs = now;
                return promise;
            }
        };
        return [2 /*return*/];
    });
}); };
exports.asyncDebounce = asyncDebounce;
var downloadFile = function (name, blob) {
    var url = window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};
exports.downloadFile = downloadFile;
var checkLocationOrigin = function () {
    if (!window.location.origin) {
        var _a = window.location, protocol = _a.protocol, hostname = _a.hostname, port = _a.port;
        // @ts-ignore
        window.location.origin = "".concat(protocol, "//").concat(hostname).concat(port && ":".concat(port));
    }
};
exports.checkLocationOrigin = checkLocationOrigin;
var initializeAnalytics = function () {
    if (window.SEND_USAGE_STATS) {
        try {
            // @ts-ignore
            react_ga_1.default.initialize('UA-90044826-2', {
                gaOptions: {
                    // @ts-ignore
                    userId: window.UUID
                }
            });
            // @ts-ignore
            react_ga_1.default.pageview(window.location.pathname + window.location.search);
        }
        catch (err) {
            console.error('Error init analytics', err);
        }
    }
};
exports.initializeAnalytics = initializeAnalytics;
var trackMessage = function (direction) {
    if (window.SEND_USAGE_STATS) {
        try {
            react_ga_1.default.event({ category: 'Interactions', action: "message ".concat(direction) });
        }
        finally {
        }
    }
};
exports.trackMessage = trackMessage;
var trackWebchatState = function (state) {
    if (window.SEND_USAGE_STATS) {
        try {
            react_ga_1.default.event({ category: 'Display', action: state });
        }
        finally {
        }
    }
};
exports.trackWebchatState = trackWebchatState;
var renderUnsafeHTML = function (message, escaped) {
    if (message === void 0) { message = ''; }
    if (escaped) {
        message = message.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    var html = (0, snarkdown_1.default)(message);
    return html.replace(/<a href/gi, '<a target="_blank" href');
};
exports.renderUnsafeHTML = renderUnsafeHTML;
var rtlLocales = [
    'ae' /* Avestan */,
    'ar' /* 'العربية', Arabic */,
    'arc' /* Aramaic */,
    'bcc' /* 'بلوچی مکرانی', Southern Balochi */,
    'bqi' /* 'بختياري', Bakthiari */,
    'ckb' /* 'Soranî / کوردی', Sorani */,
    'dv' /* Dhivehi */,
    'fa' /* 'فارسی', Persian */,
    'glk' /* 'گیلکی', Gilaki */,
    'he' /* 'עברית', Hebrew */,
    'ku' /* 'Kurdî / كوردی', Kurdish */,
    'mzn' /* 'مازِرونی', Mazanderani */,
    'nqo' /* N'Ko */,
    'pnb' /* 'پنجابی', Western Punjabi */,
    'ps' /* 'پښتو', Pashto, */,
    'sd' /* 'سنڌي', Sindhi */,
    'ug' /* 'Uyghurche / ئۇيغۇرچە', Uyghur */,
    'ur' /* 'اردو', Urdu */,
    'yi' /* 'ייִדיש', Yiddish */
];
// 'en-US' becomes ['en', '-us'] 'en' becomes ['en']
var localeRegex = /^([a-zA-Z]*)([_\-a-zA-Z]*)$/;
var isRTLLocale = function (locale) {
    if (!locale) {
        return false;
    }
    locale = locale.toLowerCase();
    var matches = localeRegex.exec(locale);
    if (!matches) {
        return false;
    }
    return rtlLocales.includes(matches[1]);
};
exports.isRTLLocale = isRTLLocale;
exports.isRTLText = new RegExp('[' +
    [
        '\u0600-\u06FF',
        '\u0750-\u077F',
        '\u08A0-\u08FF',
        '\u0870-\u089F',
        '\uFB50-\uFDFF',
        '\uFE70-\uFEFF',
        '\u0780-\u07BF',
        '\u0590-\u05FF',
        '\uFB1D-\uFB4F',
        '\u07C0-\u07FF' // N'Ko
    ].join('') +
    ']');
var ProcessedText = function (props) {
    var message;
    var hasShowMore;
    var WrapperTag;
    var _a = props.markdown, markdown = _a === void 0 ? false : _a, _b = props.escapeHTML, escapeHTML = _b === void 0 ? false : _b, _c = props.isBotMessage, isBotMessage = _c === void 0 ? false : _c, maxLength = props.maxLength, _d = props.intl, intl = _d === void 0 ? false : _d, _e = props.showMore, showMore = _e === void 0 ? false : _e, _f = props.wrapperProps, wrapperProps = _f === void 0 ? {} : _f, children = props.children;
    var tag = wrapperProps.tag, rest = __rest(wrapperProps, ["tag"]);
    var text = react_children_utilities_1.default.onlyText(children);
    if (intl && maxLength && text.length > maxLength) {
        hasShowMore = true;
    }
    var truncateIfRequired = function (message) {
        return hasShowMore && !showMore ? (0, html_truncate_1.default)(message, maxLength) : message;
    };
    if (markdown) {
        var isUserMessage = !isBotMessage;
        var shouldEscapeHTML = isUserMessage || escapeHTML;
        var html = (0, exports.renderUnsafeHTML)(text, shouldEscapeHTML);
        WrapperTag = tag || 'div';
        message = react_1.default.createElement(WrapperTag, __assign({}, rest, { dangerouslySetInnerHTML: { __html: truncateIfRequired(html) } }));
    }
    else {
        WrapperTag = tag || 'p';
        message = react_1.default.createElement(WrapperTag, __assign({}, rest), truncateIfRequired(text));
    }
    return message;
};
exports.ProcessedText = ProcessedText;
